import { render, staticRenderFns } from "./SchlierenViz.vue?vue&type=template&id=587a86a4&scoped=true"
import script from "./SchlierenViz.vue?vue&type=script&lang=js"
export * from "./SchlierenViz.vue?vue&type=script&lang=js"
import style0 from "./SchlierenViz.vue?vue&type=style&index=0&id=587a86a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a86a4",
  null
  
)

export default component.exports